import { render } from "./InfoPopup.vue?vue&type=template&id=160a5d97&ts=true"
import script from "./InfoPopup.vue?vue&type=script&lang=ts"
export * from "./InfoPopup.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__